@if (style === "white") {
    <apple-pay-button (click)="onClick()" buttonstyle="white" type="plain" locale="en-GB"></apple-pay-button>
} @else if (style === "white-outline") {
    <apple-pay-button (click)="onClick()" buttonstyle="white-outline" type="plain" locale="en-GB"></apple-pay-button>
} @else {
    <apple-pay-button (click)="onClick()" buttonstyle="black" type="plain" locale="en-GB"></apple-pay-button>
}
